import { Component, Input, OnInit } from '@angular/core';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { SharedService } from '../../../shared/shared.service';
import { ProfileService } from '../../profile.service';
import { User } from '../../types/user.model';
import { UploadProfilePicService } from '../../../shared/upload-profile-pic.service';

@Component({
  selector: 'mmb-web-app-profile-side-bar',
  templateUrl: './profile-side-bar.component.html',
  styleUrls: ['./profile-side-bar.component.scss']
})
export class ProfileSideBarComponent implements OnInit {
  @Input() user: User;
  personas: any[];
  seniorities: any[];
  userCountryConnections: any[];
  selectedIndustries: any[];
  isOtherProfile: boolean;

  constructor(private sharedService: SharedService, private userOnboardingService: UserOnboardingService,
    private profileService: ProfileService, private uploadProfilePicService: UploadProfilePicService) { }

  ngOnInit() {
    this.sharedService.referenceTypes$.subscribe((value) => {
      if (value) {
        this.seniorities = value.type_reference_user_profile_seniority;
      }
    })

    this._getPersonaOptions();
    this._getUserCountryConnections();
    this._getUserIndustries();
  }

  onFileSelect(ev) {
    const file = ev.currentTarget.files[0];

    this.uploadProfilePicService.onFileSelect(file, this.user);
  }

  openExternalLink(url: string) {
    if (url.indexOf('https://') === -1) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  }

  getSeniority(id: number) {
    return this._findValueById(this.seniorities, id);
  }

  getPersona(id: number) {
    return this._findItemById(this.personas, id);
  }

  getCurrentLocation() {
    let location = this.user.country_current ? this.user.country_current.name : '-';
    if (this.user.city_current) {
      location = `${this.user.city_current.name_ascii}, ${location}`;
    } else if (this.user.city_custom_current) {
      location = `${this.user.city_custom_current}, ${location}`;
    }
    return location;
  }

  private _getUserIndustries() {
    this.userOnboardingService.getUserPrimaryIndustry().subscribe((response) => {
      this.selectedIndustries = response;
    });
  }

  private _getUserCountryConnections() {
    this.profileService.getUserInternational().subscribe(res => {
      this._mapCountriesConnections(res);
    });
  }

  private _mapCountriesConnections(connections: any[]) {
    let connectionsBuffer = [];
    for (let connection of connections) {
      if (!connectionsBuffer[connection.country.id]) {
        connectionsBuffer[connection.country.id] = {
          country: connection.country,
          uuid: connection.uuid,
          country_statuses: []
        };
      }

      connection.country_status.recordUuid = connection.uuid;
      connectionsBuffer[connection.country.id].country_statuses.push(connection.country_status);
    }
    this.userCountryConnections = connectionsBuffer;
  }

  private _getPersonaOptions() {
    this.userOnboardingService.getUserProfileReferenceType().subscribe((response) => {
      this.personas = response;
    })
  }

  private _findItemById(items: any[], id: any) {
    return items ? items.find((item) => item.value === id) : null;
  }

  private _findValueById(items: any[], id: any) {
    let foundItem = items ? items.find((item) => item.value === id) : null;
    if (foundItem) {
      return foundItem.name;
    }
    return null;
  }

}
